import script from "./GroupableTableRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./GroupableTableRow.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QTr from 'quasar/src/components/table/QTr.js';
import QTd from 'quasar/src/components/table/QTd.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTr,QTd});
